'use strict';

// Packages
import 'jquery';
import 'jquery-hoverintent';
import '@popperjs/core';
import 'bootstrap';
import 'slick-slider';
import 'flatpickr';
//import 'jquery-datetimepicker';
// import 'perfect-scrollbar';

//components
import Main from './components/main';
import Hero from './components/hero';
import Slider from './components/slider';
import Utils from './components/utilities';

$(function() {
  new Main();
  new Hero();
  new Slider();
  new Utils();
});